import * as Yup from "yup";

const caixaValidator = Yup.object().shape({
  data: Yup.date().required("Data"),
  bancoCaixaId: Yup.number().required("Banco"),
});

export default caixaValidator;
